import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetHealthStatusQuery } from 'services/system';
import { setSystemStatus } from 'store/slices/healthStatusSlice';

export const useCheckHealthStatus = () => {
    const dispatch = useDispatch();
    /*
		Initialize status as OK assuming the system is working when the request is triggered.
		This prevents the SystemHealthNotification being rendered at the start.
	*/
    const {
        data: healthStatus = 'OK',
        isError: systemHealthError,
        isFetching: systemHealthIsFetching,
    } = useGetHealthStatusQuery('GetHealthStatus', { pollingInterval: 5_000 });

    useEffect(() => {
        /*
  		Since the systemHealthError is reset to false everytime the query is launched,
   		this conditional has been added to only allow the store update after query completion.
    */
        if (!systemHealthIsFetching) {
            dispatch(setSystemStatus(healthStatus === 'OK' && !systemHealthError));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [healthStatus, systemHealthError, systemHealthIsFetching]);
};
